import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  deliveryStatus(campaignId, executionId = null) {
    const params = executionId ? { execution_id: executionId } : {};
    const url = `${this.url}/${campaignId}/delivery_status`;
    return window.axios.get(url, { params });
  }

  exportReport(campaignId, executionId = null) {
    const params = executionId ? { execution_id: executionId } : {};
    const url = `${this.url}/${campaignId}/export_report`;

    return window.axios.get(url, {
      params,
      responseType: 'blob',
    });
  }

  pause(campaignId) {
    return window.axios.post(`${this.url}/${campaignId}/pause`);
  }

  resume(campaignId) {
    return window.axios.post(`${this.url}/${campaignId}/resume`);
  }

  stop(campaignId) {
    return window.axios.post(`${this.url}/${campaignId}/stop`);
  }
}

export default new CampaignsAPI();
